import { redirect } from "react-router-dom";

import { ROUTES } from "@/config/routes";

export const refreshAccessLoader = async () => {
  if (typeof window !== "undefined") {
    const refresh = localStorage.getItem("splay:refresh");
    const token = localStorage.getItem("splay:token");

    if (!refresh && token) {
      return redirect(ROUTES.GATE.PROFILES);
    }
  }

  return null;
};
